import React from 'react';

import { CapaQuotationChatMessageRfq } from '@generated/graphql';

import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';

import { Grid } from '@material-ui/core';

import useStyles from '../useStyles';

interface Props {
  message?: CapaQuotationChatMessageRfq;
}

const ResponseBubble: React.FC<Props> = ({ message }) => {
  const classes = useStyles({ isOwner: true });
  const rfqData = message?.rfq ?? undefined;
  const partnerOrganizationName = rfqData?.partnerOrganizationName ?? undefined;
  const partnerManagerName = rfqData?.partnerManagerName ?? '';
  const projectName = message?.rfq?.projectName ?? '';
  const titleText = '도면 다운로드 권한 승인';

  return (
    <React.Fragment>
      <Grid
        className={clsx(classes['Chat-Message-Bubble-Common-root'], {
          owner: true
        })}
        container
      >
        <CustomizedTypography
          variant="body2"
          fontWeight="bold"
          color="primary"
          gutterBottoms={8}
        >
          {titleText}
        </CustomizedTypography>
        <CustomizedTypography
          className="long-text"
          variant="body2"
          color="textPrimary"
          gutterBottoms={16}
        >
          {partnerOrganizationName ? partnerOrganizationName + ' ' : ''}
          {partnerManagerName} 님의 {projectName}의 도면 다운로드 권한을
          승인하였습니다.
        </CustomizedTypography>
      </Grid>
    </React.Fragment>
  );
};

export default ResponseBubble;
